export default "__VITE_ASSET__4f2f0621__"